import { render, staticRenderFns } from "./dataAny2.vue?vue&type=template&id=5cfd72a6&scoped=true&"
import script from "./dataAny2.vue?vue&type=script&lang=js&"
export * from "./dataAny2.vue?vue&type=script&lang=js&"
import style0 from "./dataAny2.vue?vue&type=style&index=0&id=5cfd72a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd72a6",
  null
  
)

export default component.exports